import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { OrdersService } from '../../../../core/services/orders/orders.service';
import { OrderResult } from '../../../../core/services/orders/order.models';
import { Transaction } from '../../../../core/services/transactions/transactions.model';
import { TransactionsService } from '../../../../core/services/transactions/transactions.service';
import { ORDER_STATUS } from '../../../../core/services/orders/orders.constant';

@Injectable()
export class DashboardOrderService implements Resolve<any>
{
    routeParams: any;
    order: OrderResult;
    transactions: Transaction[];
    dueAmount: number;

    onOrderChanged: BehaviorSubject<any> = new BehaviorSubject({});
    onTransactionChanged: BehaviorSubject<any> = new BehaviorSubject({});
    onDueAmountChanged: BehaviorSubject<any> = new BehaviorSubject({});
    onProductChanged: BehaviorSubject<any> = new BehaviorSubject({});

    constructor(
        private readonly orderService: OrdersService,
        private readonly transactionsService: TransactionsService,
    ) {}

    /**
     * Resolve
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {Observable<any> | Promise<any> | any}
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {

        this.routeParams = route.params;

        return new Promise((resolve, reject) => {

            Promise.all([
                this.getOrder(),
                this.getTransactions(),
                this.getDueAmount(),
            ]).then(
                () => {
                    resolve(true);
                },
                reject
            );
        });
    }

    getOrder() {
        return new Promise((resolve, reject) => {
            this.orderService.get(this.routeParams.id)
                .subscribe((response: OrderResult) => {
                    this.order = response;
                    this.onOrderChanged.next(this.order);
                    resolve(response);
                }, reject);
        });
    }

    getTransactions() {
        return new Promise((resolve, reject) => {
            this.transactionsService.listOrder(this.routeParams.id)
                .subscribe((response) => {
                    this.transactions = response;
                    this.onTransactionChanged.next(this.transactions);
                    resolve(response);
                }, reject);
        });
    }

    getDueAmount() {
        return new Promise((resolve, reject) => {
            this.transactionsService.dueAmount(this.routeParams.id)
                .subscribe((response) => {
                    this.dueAmount = response;
                    this.onDueAmountChanged.next(this.dueAmount);
                    resolve(response);
                }, reject);
        });
    }

    addTransac(data: any) {
        return new Promise((resolve, reject) => {
            this.transactionsService.add({
                orderId: this.routeParams.id,
                type: data.type,
                amount: data.vads_amount,
            })
                .subscribe((response: OrderResult) => {
                    this.order = response;
                    this.getTransactions();
                    this.getDueAmount();
                    this.onOrderChanged.next(this.order);
                    resolve(response);
                }, reject);
        });

    }

    setStatus(status: string) {
        return new Promise((resolve, reject) => {
            this.orderService.setStatus(this.routeParams.id, status)
                .subscribe((response) => {
                    this.order = response;
                    this.onOrderChanged.next(this.order);
                    resolve(response);
                }, reject);
        });
    }

    getStatusLabel(status: string) {
        switch (status) {
            case ORDER_STATUS.PREORDER_RESERVED:
                return 'ATTENTE DE VALIDATION';
            case ORDER_STATUS.PREORDER_CONFIRMED:
                return 'ATTENTE SIGNATURE';
            case ORDER_STATUS.PREORDER_AWAITING_PAYMENT:
                return 'ATTENTE REGELEMENT';
            case ORDER_STATUS.PREORDER_PAID:
                return 'FACTURE ACQUITEE';
            case ORDER_STATUS.PREORDER_CANCELED:
                return 'ANULEE';
            case ORDER_STATUS.PREORDER_CANCELEDBYUSER:
            case ORDER_STATUS.ORDER_CANCELEDBYUSER:
                return 'ANULEE PAR LE CLIENT';
            default:
                return status;
        }
    }

    getStatusClass(status: string) {
        return this.orderService.getStatusClass(status);
    }

    resendEmail(id: string) {
        return this.orderService.resendEmail(id);
    }

    sendPaymentLink(id: string) {
        return this.orderService.sendPaymentLink(id);
    }

    sendPaymentReminder(id: string) {
        return this.orderService.sendPaymentReminder(id);
    }

    getProduct(id: string, date: Date) {
        return new Promise((resolve, reject) => {
            this.orderService.getProduct(id, date)
                .subscribe((response) => {
                    resolve(response);
                }, reject);
        });
    }

    refund() {
        return new Promise((resolve, reject) => {
            this.orderService.refund(this.routeParams.id)
                .subscribe((response) => {
                    this.getOrder();
                    this.getTransactions();
                    resolve(response);
                }, reject);
        });
    }

    saveOrder(order: OrderResult) {
        return new Promise((resolve, reject) => {
            this.orderService.save(order)
                .subscribe((response: any) => {
                    this.getOrder();
                    this.getDueAmount();
                    resolve(response);
                }, reject);
        });
    }
}



// WEBPACK FOOTER //
// /usr/app/src/app/main/content/app/order/order.service.ts